import { FilterTableColByFeatFlagPipe } from '../../../../common/pipes/filter-table-col-by-featFlag/filter-table-col-by-feat-flag.pipe';
import { TableComponent } from '../../../../../ui-components/lib/table/table.component';
import { PaginatorComponent } from '../../../../../ui-components/lib/paginator/paginator.component';
import { SlaDirective } from '../../../../common/directives/sla/sla.directive';
import { AvatarComponent } from '../../../../../ui-components/lib/avatar/avatar.component';
import { TruncatePipe } from '../../../../../ui-components/pipes/truncate/truncate.pipe';
import { TrimTooltipDirective } from '../../../../../ui-components/directives/trim-tooltip/trim-tooltip.directive';
import { ActionListComponent } from '../../../../common/components/action-list/action-list.component';
import { FilterDropdownComponent } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.component';
import { HoldIconComponent, ClockIconComponent } from '@kuiper/icons';
import { UserDropdownViewComponent } from '../../../../../ui-components/lib/user-dropdown-view/user-dropdown-view.component';
import { ExportComponent } from '../../../../../ui-components/lib/export/export.component';
import { RequestCreatorComponent } from '../../../../common/components/request-creator/request-creator.component';
import { TenantPathPipe } from '../../../../common/pipes/tenant-path/tenant-path.pipe';
import { SearchFieldComponent } from '../../../../../ui-components/lib/search-field/search-field.component';
import { BadgeComponent } from '../../../../../ui-components/lib/badge/badge.component';
import { StepStatusPipe } from '../../../../common/pipes/step-status/step-status.pipe';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { RelatedRequestsDropdownComponent } from '../../../../../ui-components/lib/related-requests-dropdown/related-requests-dropdown.component';
import { StatComponent } from '../../../../../ui-components/lib/stat/stat.component';
import { FilteredTableComponent } from '../../../../common/components/filtered-table/filtered-table.component';
import { RequestSummaryCellComponent } from '../../../../common/components/request-summary-cell/request-summary-cell.component';
import { RequestSummaryTemplatesPipe } from '../../../../common/pipes/request-summary-templates/request-summary-templates.pipe';
import { SlaSummaryCellComponent } from '../../../../common/components/sla-summary-cell/sla-summary-cell.component';
import { SlaSummaryTemplatesPipe } from '../../../../common/pipes/sla-summary-templates/sla-summary-templates.pipe';

/* Exports */
export {
  inject,
  signal,
  viewChild,
  TemplateRef,
  DestroyRef,
  type Signal,
} from '@angular/core';
export { ActivatedRoute, Router } from '@angular/router';
export { FormControl, FormGroup } from '@angular/forms';
export { TranslocoService } from '@jsverse/transloco';
export { takeUntilDestroyed } from '@angular/core/rxjs-interop';
export { finalize } from 'rxjs';
export { SearchService } from '../../../../../ui-components/lib/search-field/search.service';
export { FilterDropdownService } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.service';
export { ToasterService } from '../../../../../ui-components/services/toast/toast.service';
export { ExportService } from '../../../../../ui-components/services/export/export.service';
export { ModalServiceService } from '../../../../../ui-components/lib/modal/modal-service.service';
export { FilterMapping } from '../../../../../ui-components/lib/filter-dropdown/filter-mapping.enum';
export { MyInboxService } from '../../../../common/services/my-inbox/my-inbox.service';
export { TenantService } from '../../../../common/services/tenant/tenant.service';
export { RequestTypeEnum } from '../../../../common/enums/request-type';
export { StepStatusEnum } from '../../../../common/enums/step-status';
export { SearchEnum } from '../../../../common/enums/search.enum';
export { AppStorage } from '../../../../common/enums/app-storage';
export type { FilterOption } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
export type {
  TableColumns,
  TableFilterTab,
} from '../../../../../ui-components/lib/table/table.model';
export type { ActionList } from '../../../../common/models/action-list.model';
export type { StepTask } from '../../../../common/models/step-task.model';
export type { CurrentAssignee } from '../../../../common/models/assignee.model';
export type { ApiResponse } from '@kuiper/ibusiness-core';
export {
  FILTER_OPTIONS,
  ON_HOLD_COLUMNS,
  TABLE_FILTER_TABS,
  VIEW_DETAILS_ACTION,
} from './contributed-tasks.constants';
export { COLUMN_IDENTIFIERS } from '../../const';
export { filterQueryParamName } from '../../../../../ui-components/lib/table/table.model';
export { DEFAULT_PAGE_SIZE_OPTIONS } from '../../../../common/constants/pagination.constants';
export { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
export type { Insight } from './../../../../common/models/insight.model';
export { CONTRIBUTED_TASKS_INSIGHTS } from './contributed-tasks.constants';
export { FeatureFlagsService } from '../../../../common/services/feature-flags/feature-flags.service';
export { FEATURE_FLAGS } from '../../../../common/constants/feature-flags.constants';
export { isFeatureFlaggedColumnVisible } from '../../../../common/helpers/feature-flagged-table-columns/feature-flagged-table-columns.helper';

export const CONTRIBUTED_TASKS_COMPONENT_IMPORTS = [
  RequestSummaryCellComponent,
  RequestSummaryTemplatesPipe,
  SlaSummaryCellComponent,
  SlaSummaryTemplatesPipe,
  FilterTableColByFeatFlagPipe,
  TableComponent,
  PaginatorComponent,
  SlaDirective,
  AvatarComponent,
  TruncatePipe,
  TrimTooltipDirective,
  ActionListComponent,
  FilterDropdownComponent,
  ClockIconComponent,
  HoldIconComponent,
  UserDropdownViewComponent,
  ExportComponent,
  RequestCreatorComponent,
  TenantPathPipe,
  SearchFieldComponent,
  BadgeComponent,
  StepStatusPipe,
  DatePipe,
  ReactiveFormsModule,
  RouterLink,
  TranslocoPipe,
  StatComponent,
  FilteredTableComponent,
  RelatedRequestsDropdownComponent,
];
